import * as Sentry from '@sentry/react';
import {
  DeleteApiKeyProps,
  deleteCapitolKey,
} from '@/services/keys/delete-capitol-key';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export const useDeleteCapitolKey = (
  options?: Omit<
    UseMutationOptions<unknown, Error, DeleteApiKeyProps, unknown>,
    'mutationFn'
  >,
) => {
  return useMutation({
    ...options,
    mutationFn: deleteCapitolKey,
    onError: (error, variables, context, mutation) => {
      Sentry.captureException(error, {
        extra: { context: 'delete-capitol-key', keyId: variables.id },
      });
      options?.onError?.(error, variables, context, mutation);
    },
  });
};
